import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      flexDirection: 'column',
      width: '100%',
    };

    this.content = {
      backgroundColor: '#f5f5f5',
      borderRadius: '12px',
      p: [3, 4],
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
    };

    this.addToCart = {
      backgroundColor: '#000000',
      color: '#ffffff',
      fontFamily: 'body',
      fontWeight: 500,
      fontSize: ['14px', '15px'],
      borderRadius: '24px',
      border: 'none',
      px: [3, 4],
      py: [2, 3],
      mt: 'auto',
      cursor: 'pointer',
      textAlign: 'center',
      textDecoration: 'none',
      display: 'flex',
      transition: 'all 0.2s ease',
      minHeight: ['40px', '44px'],
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: '#333333',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.2)',
      },
    };
  })()
);
